import React, { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import Backdrop from "Components/Common/Backdrop";
import { getOptionValue } from "common/enums";

import { useLazyGetPaymentTransactionConfirmation } from "apis/Payment";

const MakePayment = () => {
  const encRef = useRef();
  const formRef = useRef();
  const accessCodeRef = useRef();
  const [searchParams] = useSearchParams();
  const encryptedUrl = searchParams.get("paymentRequest");
  const moduleType = searchParams.get("moduleType");
  const moduleTypeId = searchParams.get("moduleTypeId");

  const navigate = useNavigate();
  const [getPaymentConfirmation] = useLazyGetPaymentTransactionConfirmation();

  const handleClick = async () => {
    try {
      const myForm = formRef.current;
      const encRequestElement = encRef.current;
      const accessCodeElement = accessCodeRef.current;
      encRequestElement.value = encryptedUrl;
      accessCodeElement.value = process.env.REACT_APP_CCAVENUE_ACCESS_CODE;
      myForm.submit();
    } catch (error) {}
  };

  useEffect(() => {
    (async () => {
      try {
        await getPaymentConfirmation({
          moduleType: getOptionValue("moduleTypes", moduleType),
          moduleTypeId,
        });
        handleClick();
      } catch (error) {
        navigate("/");
      }
    })();
  }, []);

  return (
    <>
      <Backdrop open />
      <form
        ref={formRef}
        method="post"
        action={process.env.REACT_APP_CCAVENUE_PAYMENT_URL}
      >
        <input type="hidden" name="encRequest" ref={encRef} />
        <input type="hidden" name="access_code" ref={accessCodeRef} />
      </form>
    </>
  );
};

export default MakePayment;
